import * as React from 'react';
import { useDispatch } from 'react-redux';

import { TTypedThunkDispatch } from '../../types/thunk';
import { trackingActionClickAgentsFlats, trackingActionClickDevelopersFlats } from '../../actions/analytics';
import { Link } from '@cian/ui-kit';
import { IFromDevelopersRoom } from '../../types/newbuilding';

interface IRoomCountsProps {
  fromAgentsPropsLink?: string;
  fromDeveloperPropsLink?: string;
  fromDeveloperCountsDisplay?: string;
  fromAgentsCountsDisplay?: string;
  fromDevelopersRooms: IFromDevelopersRoom[];
}

export function RoomCounts(props: IRoomCountsProps) {
  const {
    fromDeveloperPropsLink,
    fromDeveloperCountsDisplay,
    fromAgentsCountsDisplay,
    fromAgentsPropsLink,
    fromDevelopersRooms,
  } = props;

  const dispatch = useDispatch<TTypedThunkDispatch>();

  const trackingClickDevelopersFlats = React.useCallback(() => {
    if (fromDeveloperPropsLink) {
      dispatch(trackingActionClickDevelopersFlats('all-variants'));
    } else {
      dispatch(trackingActionClickAgentsFlats());
    }
  }, [dispatch, fromDeveloperPropsLink]);

  if (!fromDevelopersRooms || !fromDevelopersRooms.length) {
    return null;
  }

  if (!fromDeveloperPropsLink && !fromAgentsPropsLink) {
    return null;
  }

  const link = fromDeveloperPropsLink || fromAgentsPropsLink;
  const text = fromDeveloperPropsLink
    ? fromDeveloperCountsDisplay
    : `${fromAgentsCountsDisplay} от агентов и собственников`;

  return (
    <Link fontSize="M" fontWeight="bold" onClick={trackingClickDevelopersFlats} href={link} target="_blank">
      {text}
    </Link>
  );
}
